import React from 'react';
import News from './News';

const HomePage = () => {
  const containerStyle = {
    padding: '3rem 1.5rem',
    fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    maxWidth: '1200px',
    margin: '0 auto',
    minHeight: '85vh',
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
    backgroundColor: '#fdfdfd'
  };

  const headerStyle = {
    textAlign: 'center',
    padding: '2rem 0',
    background: 'linear-gradient(to bottom, #fff, #fdfdfd)',
    borderRadius: '20px',
    marginBottom: '1rem'
  };

  const titleStyle = {
    color: '#b30000',
    fontSize: '2.8rem',
    fontWeight: '800',
    marginBottom: '1rem',
    letterSpacing: '-0.5px'
  };

  const subTitleStyle = {
    fontSize: '1.25rem',
    color: '#555',
    maxWidth: '700px',
    margin: '0 auto',
    lineHeight: '1.6'
  };

  const sectionTitleStyle = {
    fontSize: '1.8rem',
    color: '#333',
    borderBottom: '3px solid #b30000',
    paddingBottom: '0.8rem',
    marginBottom: '2rem',
    display: 'inline-block'
  };

  const footerStyle = {
    marginTop: 'auto',
    padding: '3rem 0',
    borderTop: '1px solid #eee',
    textAlign: 'center',
    color: '#888',
    fontStyle: 'italic',
    fontSize: '0.95rem'
  };

  return (
    <main style={containerStyle}>
      {/* FEJLÉC ÉS ÜDVÖZLÉS */}
      <header style={headerStyle}>
        <h1 style={titleStyle}>Üdvözöl az ArcheryNexus!</h1>
        <p style={subTitleStyle}>
          A magyar íjász közösség találkozóhelye. Itt megtalálhatod a legfrissebb szövetségi híreket,
          az aktuális versenyeket és minden fontos információt egy helyen.
        </p>
      </header>

      {/* HÍREK SZEKCIÓ */}
      <section>
        <h2 style={sectionTitleStyle}>Hírek a Magyar Íjász Szövetségtől</h2>
        <News />
      </section>

      {/* FEJLESZTÉS ALATT ÜZENET */}
      <footer style={footerStyle}>
        <div style={{ marginBottom: '10px' }}>🏹 ArcheryNexus v1.0 (Web)</div>
        <p>
          Az oldal folyamatos fejlesztés alatt áll. Hamarosan új tartalmakkal érkezünk!
        </p>
      </footer>
    </main>
  );
};

export default HomePage;



